<script>
	module.exports = {
		name: 'product-selector',
		props: {
			products: {
				required: true
			},
			gcAddon: {
				type: Object
			},
			onProductClick: {
				type: Function,
				default() {}
			},
			onFeatureClick: {
				type: Function,
				default() {}
			},
			onSubTypeClick: {
				type: Function,
				default() {}
			}
		},
		components: {
			'product-selection-hidden-radio-group': require('components/product-selection-hidden-radio-group.vue').default,
			'input-item-with-label': require('components/input-item-with-label.vue').default
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/flexbox';
	@import 'config/variables';

	.product-selector {
		margin-bottom: 0rem;
		label {
			margin-bottom: $size-xs;
		}
		.product {
			@include flexbox();
			input {
				margin-top: $size-xs;
				& + label {
					@include flex(1);
					padding-left: $size-small;
				}
			}
		}
		.product-container .product-container {
			margin-left: $size-medium;
			.item-label {
				color: $c-slate-dark;
			}
			.section-header {
				margin-top: 0.25rem;
			}
		}
	}
</style>
<template>
	<div class="product-selector">
		<div
			v-for="product in products"
			:key="product.id"
			:class="['product-container', product.id]">
			<template v-if="product.type === 'hidden-radio-group'">
				<product-selection-hidden-radio-group
					:product="product"
					:on-product-click="onProductClick">
				</product-selection-hidden-radio-group>
			</template>
			<template v-else>
				<input-item-with-label
					:item="product"
					:gc-addon="gcAddon"
					:on-item-click="onProductClick">
				</input-item-with-label>
			</template>
			<product-selector
				v-if="product.features && product.features.length"
				:products="product.features"
				:on-product-click="onFeatureClick">
			</product-selector>
			<product-selection-hidden-radio-group
				v-else-if="product.subTypes && product.subTypes.length > 1"
				:product="product"
				:on-product-click="onSubTypeClick"
				visible>
			</product-selection-hidden-radio-group>
		</div>
	</div>
</template>
